import { CollectionResources } from "../../collections/CollectionResources"

type WazKBManageProps = {

}

export const WazKBManage = ({} : WazKBManageProps) => {

    return (
        <CollectionResources />
    )
}